import { gql } from "@apollo/client";

export const GET_AUDITS = gql`
  query getAudits($page: Int, $limit: Int, $filter: AuditFilterInputType) {
    getAudits(page: $page, limit: $limit, filter: $filter) {
      statusCode
      success
      message
      data {
        id
        audit_name
        framework_id
        auditors {
          id
          is_internal
          name
          email
        }
        audit_type
        audit_status
        audit_start_date
        audit_end_date
        rego_valid_till
        rego_valid_from
        total_controls
        customer_name
      }
      totalCount
    }
  }
`;

export const CREATE_AUDIT = gql`
  mutation createAudit($input: AuditCreateInputType!) {
    createAudit(input: $input) {
      statusCode
      success
      message
      data {
        id
        framework_id
        auditors {
          id
          is_internal
          name
          email
        }
        audit_type
        audit_status
        audit_start_date
        audit_end_date
        rego_valid_till
        rego_valid_from
      }
    }
  }
`;

export const UPDATE_AUDIT = gql`
  mutation updateAudit($input: [AuditUpdateInputType!]!) {
    updateAudit(input: $input) {
      statusCode
      success
      message
      data {
        id
        success
        error
      }
    }
  }
`;

export const GET_AUDIT_CONTROLS = gql`
  query getAuditControls($audit_id: ID!) {
    getAuditControls(audit_id: $audit_id) {
      statusCode
      success
      message
      data {
        audit_control_id
        control_id
        controls_name
        controls_description
        controls_title
        controls_domain
        area_name
        criteria_name
        total_checks
        passed_checks
        readiness_percentage
      }
      totalCount
    }
  }
`;

export const GET_AUDIT_CHECKS = gql`
  query getAuditChecks($audit_id: ID!) {
    getAuditChecks(audit_id: $audit_id) {
      statusCode
      success
      message
      data {
        audit_check_id
        check_id
        active_check_name
        active_check_description
        active_check_category
        check_type
        monitor_type
        status
        status_reason
        controls_id
        controls_name
      }
      totalCount
    }
  }
`;

export const GET_AUDIT_PLAN_FILES = gql`
  query getAuditPlanFiles($audit_id: ID!) {
    getAuditPlanFiles(audit_id: $audit_id) {
      fileId
      fileUuid
      maskName
      path
      isFileValid
      fileRejectReason
      createdAt
      updatedAt
    }
  }
`;

export const GET_AUDIT_CONTROL_CHECK_DATA = gql`
  query getAuditControlCheckData($audit_id: ID!, $control_id: Int!) {
    getAuditControlCheckData(audit_id: $audit_id, control_id: $control_id) {
      activeCheckId
      hasData
    }
  }
`;

export const GET_AUDIT_FRAMEWORK_MIDDLE_PANEL = gql`
  query getAuditFrameworkMiddlePanel($audit_id: ID!) {
    getAuditFrameworkMiddlePanel(audit_id: $audit_id) {
      frameworkId
      frameworkName
      frameworkLogo
      frameworkDescription
      launchstatus
      standard
      category
      is_active
      areaDetails {
        area_id
        area_name
        criterias {
          criteria_id
          criteria
          criteria_description
          controls {
            auditControlId
            controlsId
            controlsName
            controlsDescription
            controlsDomain
            controlsTitle
            status
            redFlag
            policies {
              policyId
              policyName
              policyDisplayName
              policyDescription
              isActive
              policyFileName
              category
            }
            checks {
              activeCheckId
              activeCheckName
              activeCheckDescription
              checkType
              monitorType
              activeCheckCategory
              checkStatus
              checkStatusReason
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_AUDIT_CONTROL_STATUS = gql`
  mutation updateAuditControlStatus(
    $audit_control_id: ID!
    $audit_id: ID
    $status: AuditControlStatus
    $red_flag: Boolean
  ) {
    updateAuditControlStatus(
      audit_control_id: $audit_control_id
      audit_id: $audit_id
      status: $status
      red_flag: $red_flag
    ) {
      success
      message
      status_id
      red_flag
    }
  }
`;
